import PropTypes from "prop-types"
import { useMemo } from "react"
import { useSelector } from "react-redux"

import AddonLineItem from "./line-item"

const AddonLineItems = ({ setOnRemoveAction }) => {
  const addons = useSelector((state) => state.cart.addons)
  const filteredAddons = useMemo(
    () =>
      (addons || []).filter((addon) =>
        ["BUNDLE", "GIFT_CARD"].includes(addon.addon_type)
      ),
    [addons]
  )

  if (!filteredAddons?.length) return null

  return filteredAddons.map((addon, index) => (
    <AddonLineItem
      addon={addon}
      index={index}
      key={`d_addon-${addon.id}`}
      setOnRemoveAction={setOnRemoveAction}
    />
  ))
}

AddonLineItems.propTypes = {
  setOnRemoveAction: PropTypes.func,
}

export default AddonLineItems
